import { useMutation } from '@tanstack/react-query';
import * as api from 'util/api';

export default ({ onSuccess, onError, onSettled } = {}) => useMutation({
  mutationKey: ['segmentation', 'create-runs'],
  mutationFn: ({ regions, autoApply }) => api.createSegmentationRuns(regions, autoApply),
  onSuccess,
  onError,
  onSettled,
});
